import { AmountUtils, cn, CurrencyUtils } from '@shared/utils';
import type { GetAccountsResponse } from '@shared/api';
import { Button } from '@shared/widgets';
import bgImg from '@assets/images/accountSlider-bg.jpg';

interface AccountSlideItemType {
  account: GetAccountsResponse;
  onSelectAccount: (data: GetAccountsResponse | undefined) => void;
  onShowTopUpModal: () => void;
}

export const AccountSlideItem = (props: AccountSlideItemType) => {
  return (
    <>
      <div className={cn('absolute top-0 left-0 z-2 h-full w-full rotate-y-0 duration-300 backface-hidden', 'hover:scale-95')}>
        <div
          className={cn('relative flex h-full rounded bg-cover bg-no-repeat shadow-[12px_12px_24px_0_#0000003b] duration-100', 'hover:scale-95')}
          style={{ backgroundImage: `url(${bgImg})` }}
        />
        <div
          className={cn(
            'absolute top-0 right-0 bottom-0 left-0 flex items-center justify-center text-4xl font-bold text-[#f2f2f2]',
            'not-lg:text-3xl',
          )}
        >
          <div className='mr-1'>{CurrencyUtils.getSymbolByCode(props.account.Currency)}</div>
          <div className='uppercase'>{props.account.Currency}</div>
        </div>
      </div>
      <div className='absolute top-0 left-0 h-full w-full rotate-y-180 backface-hidden'>
        <div
          className='relative flex h-full items-center justify-center rounded bg-cover bg-right bg-no-repeat shadow-[12px_12px_24px_0_#0000003b]'
          style={{ backgroundImage: `url(${bgImg})` }}
        >
          <div className='text-white'>
            <div className={cn('mb-4 flex items-center justify-start text-xl', 'not-lg:mb-1 not-lg:text-lg')}>
              <div className='mr-1'>{CurrencyUtils.getSymbolByCode(props.account.Currency)}</div>
              <div className='uppercase'>{props.account.Currency}</div>
            </div>
            <div className={cn('text-4xl font-bold', 'not-lg:text-3xl')}>{AmountUtils.transformToAmount(props.account.Amount)}</div>
          </div>
          <div className={cn('absolute right-5 bottom-6 h-12 w-[96px]', 'not-lg:h-8 not-lg:w-[68px]')}>
            <Button fullWidth onClick={() => (props.onSelectAccount(props.account), props.onShowTopUpModal())}>
              Top up
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
